module.exports = __webpack_public_path__ + "static/media/icon_megaphone.616fb9c3.svg";